import { useNavigate } from 'react-router-dom';
import { MoreVertical, ChevronLeft } from 'lucide-react';

import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Button } from '@/components/ui/button';

import { CONVERSATION_TYPE } from '../../enums';
import { getConversationTitle } from '../../helpers';

import { useSelf } from '@/data/user';

const ConversationHeader = ({ conversation }) => {
  const navigate = useNavigate();
  const self = useSelf();

  const { title, avatarFallback } = getConversationTitle(
    conversation,
    self.data
  );

  return (
    <div className="fixed top-0 left-0 right-0 backdrop-blur-sm border-b py-3 px-4 z-50">
      <div className="flex items-center justify-between">
        <ChevronLeft
          className="w-10 h-10 cursor-pointer -my-2"
          onClick={() => navigate('/conversation')}
        />
        <div className="flex items-center gap-3">
          <Avatar className="h-10 w-10">
            <AvatarImage src={conversation.avatar} alt={title} />
            <AvatarFallback>{avatarFallback}</AvatarFallback>
          </Avatar>
          <div className="flex flex-col">
            <h1 className="text-xl font-bold truncate max-w-[200px]">
              {title}
            </h1>
            {(conversation.users.length > 2 ||
              conversation.type === CONVERSATION_TYPE.BOOKING) && (
              <p className="text-sm text-muted-foreground">
                {conversation.users
                  .filter((u) => u.userId !== self.data.id)
                  .map((u) => `${u.user.firstname} ${u.user.lastname}`)
                  .join(', ')}
              </p>
            )}
          </div>
        </div>
        <Button variant="ghost" size="icon">
          <MoreVertical className="h-6 w-6" />
        </Button>
      </div>
    </div>
  );
};

export default ConversationHeader;
